import { ElectionsLogo } from '@/assets/icons';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

// --- 1. Define Keyframes (Replicating logo-entry) ---
const logoEntry = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0); /* Settle at final position */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

// --- 2. Define Keyframes for Continuous Pulse ---
const pulse = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
`;

// --- 3. Styled Component for the Logo Container ---
const LogoContainer = styled(Box)(() => ({
  width: 150,
  height: 150,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  // Chain animations: 
  // 1. Entry (1.5s, runs once)
  // 2. Pulse (3s, infinite, starts after 1.5s delay)
  animation: `${logoEntry} 1.5s cubic-bezier(0.4, 0, 0.2, 1) forwards, ${pulse} 3s ease-in-out 1.5s infinite`,

  // Optimization hint
  willChange: 'transform, opacity, box-shadow',

  // Initial state before animation starts
  opacity: 0,
  transform: 'scale(0.8) translateY(20px)',

  // Accessibility: Disable animations for users who prefer reduced motion
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: 1,
    transform: 'scale(1)',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
  },
}));

const Loader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        overflow: 'hidden',
      }}
    >
      <LogoContainer aria-label="Application Logo">
        <ElectionsLogo />
      </LogoContainer>
    </Box>
  )
}

export default Loader
